import {
  ChangeDetectorRef,
  Component,
  
  Inject,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { interval, Subject, Subscription } from "rxjs";
import { AuthService } from "../../services/auth.service";
import { Customer } from "../../models/customers/Customer";
import { environment } from "../../../environments/environment";
import { AmpelChatService } from "@app/services/ampelchat.service";
import { takeUntil } from "rxjs/operators";
import { DOCUMENT } from "@angular/common";
@Component({
  selector: "app-chatampel",
  templateUrl: "./chatampel.component.html",
  styleUrls: ["./chatampel.component.scss"],
  standalone: false,
})
export class ChatampelComponent implements OnInit, OnDestroy {
  private sub: Subscription;
  private unsubscribe$ = new Subject();
  socket: any;
  currentCustomer: Customer;
  rot: string = "#E64A19";
  gelb: string = "#FBC02D";
  grun: string = "#388E3C";
  loading: boolean = false;

  countrot: number = 0;
  countgelb: number = 0;
  countgrun: number = 0;

  chattm1;
  chattm2;
  constructor(
    private authService: AuthService,
    private ampelChatService: AmpelChatService,
    @Inject(DOCUMENT) protected document: any,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.authService.auth$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((customer: Customer) => {
        this.currentCustomer = customer;
        if (this.currentCustomer?.asPartner) {
          this.initData();
        }
      });
  }

  async initData() {
    this.ampelChatService.connectToServer(
      this.currentCustomer.partnerid + "_" + this.currentCustomer.email,
      this.currentCustomer.partnerid,
      (err) => {
        if (!err) {
          this.updateample();
          this.sub && this.sub.unsubscribe();
          const every10min$ = interval(10000);
          this.sub = every10min$.subscribe(() => {
            this.updateample();
          });
        }
      }
    );
  }

  async updateample() {
    this.loading = true;
    this.cdr.detectChanges();
    this.ampelChatService.updateample(
      this.currentCustomer.partnerid,
      this.currentCustomer.email,
      (users) => {
        this.updatelastUserColor(users);
      }
    );
  }

  async updatelastUserColor(chatUsers) {
    this.countrot = 0;
    this.countgelb = 0;
    this.countgrun = 0;
    for (let i = 0; i < chatUsers?.length; i++) {
      const lchng = new Date(
        chatUsers[i].messages[
          chatUsers[i].numberofmessages - 1
        ]?.to?.last_connection
      );
      if (
        chatUsers[i].messages[chatUsers[i].numberofmessages - 1].to.username !==
        chatUsers[i].target.username
      ) {
        if (Date.now() - lchng.getTime() > 60000) {
          this.countrot += 1;
        } else if (Date.now() - lchng.getTime() > 30000) {
          this.countgelb += 1;
        } else {
          this.countgrun += 1;
        }
      } else if (chatUsers[i].color !== this.rot) {
        chatUsers[i].color = this.grun;
      }
    }
    setTimeout(() => {
      this.loading = false;
      this.cdr.detectChanges();
    }, 1000);
  }

  
  ngOnDestroy(): void {
    this.sub && this.sub.unsubscribe();
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  async gotoBackoffice() {
    let url = this.document.domain;
    if (!environment.production) {
      url = "https://localhost:33335";
    } else {
      url = "https://backoffice." + url;
    }
    window.open(url, "_blank", "noopener");
  }
}
